module.exports = __webpack_public_path__ + "img/linkedin.0cbcbbd1.svg";